export default __webpack_public_path__ + "static/media/beaker.a66f6959.png";